import React from "react";
import { Banner } from "./Banner";
import type {
  ShopBannerEntity,
  ShopEntity,
} from "../../../../../../domain/types/company-shop";

interface PreviewBannerProps {
  shopEntityData: ShopEntity | null;
  bannersData: ShopBannerEntity[] | null;
}

export const PreviewBanner = ({
  shopEntityData,
  bannersData,
}: PreviewBannerProps) => {
  // 배너가 한 장도 없으면 빈 캐러셀이 남아 레이아웃만 밀리므로 통째로 감춘다
  if (!(bannersData?.length && bannersData.length > 0)) {
    return null;
  }

  return (
    <div className="relative bg-white w-full aspect-[700/380] flex justify-between items-center">
      <div className="absolute top-0 bottom-0 left-0 right-0">
        <Banner
          slidingInterval={shopEntityData?.designProductSlideInterval ?? 5}
          shopEntityData={shopEntityData}
          bannersData={bannersData}
        />
      </div>

      {/*
        화살표 버튼의 bg-gray-50 은 쇼핑몰 `.banner-slider__btn` 의
        `background: transparent` 와 다르다. 다만 미리보기에서 투명으로 두면
        배너 이미지 위에서 화살표가 거의 안 보여 미리보기 구실을 못 한다.
        의도적으로 남긴 차이다 (F-10).
      */}
      <div className="relative z-50 flex flex-row justify-between w-full p-[0.8rem]">
        <div
          className="bg-gray-50 opacity-[0.9] / aspect-[1/1] w-[2.125rem]
                  / flex justify-center items-center / rounded-full"
        >
          <img
            className="w-[0.6837rem]"
            alt="왼쪽 화살표 아이콘"
            src="/assets/icons/Arrow - Left 2.svg"
          />
        </div>

        <div
          className="bg-gray-50 opacity-[0.9] / aspect-[1/1] w-[2.125rem]
                  / flex justify-center items-center / rounded-full"
        >
          <img
            className="w-[0.6837rem]"
            alt="오른쪽 화살표 아이콘"
            src="/assets/icons/Arrow - Right 2.svg"
          />
        </div>
      </div>
    </div>
  );
};
